/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The wheel runs entirely in your browser and your options are not stored or uploaded.`)
};

const es_dw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La rueda funciona por completo en tu navegador y tus opciones no se guardan ni se suben.`)
};

const de_dw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Das Rad läuft vollständig in deinem Browser, und deine Optionen werden weder gespeichert noch hochgeladen.`)
};

const nl_dw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Het rad draait volledig in je browser en je opties worden niet opgeslagen of geüpload.`)
};

const fr_dw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. La roue fonctionne entièrement dans votre navigateur et vos options ne sont ni stockées ni envoyées sur un serveur.`)
};

const it_dw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La ruota funziona interamente nel tuo browser e le tue opzioni non vengono memorizzate o caricate online.`)
};

const pt_br2_dw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A roleta roda inteiramente no seu navegador e suas opções não são armazenadas nem enviadas.`)
};

const pt_dw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A roda funciona inteiramente no seu navegador e as suas opções não são guardadas nem enviadas.`)
};

const ja_dw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。ホイールはブラウザ内で完全に処理され、選択肢は保存もアップロードもされません。`)
};

const zh_dw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。转盘完全在你的浏览器中运行，你的选项不会被存储或上传。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_faq_a4", locale)
	if (locale === "en") return en_dw_faq_a4(inputs)
	if (locale === "es") return es_dw_faq_a4(inputs)
	if (locale === "de") return de_dw_faq_a4(inputs)
	if (locale === "nl") return nl_dw_faq_a4(inputs)
	if (locale === "fr") return fr_dw_faq_a4(inputs)
	if (locale === "it") return it_dw_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_dw_faq_a4(inputs)
	if (locale === "pt") return pt_dw_faq_a4(inputs)
	if (locale === "ja") return ja_dw_faq_a4(inputs)
	return zh_dw_faq_a4(inputs)
};